import { render, staticRenderFns } from "./dob.vue?vue&type=template&id=6d858862&scoped=true&lang=pug&"
import script from "./dob.vue?vue&type=script&lang=js&"
export * from "./dob.vue?vue&type=script&lang=js&"
import style0 from "./dob.vue?vue&type=style&index=0&id=6d858862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d858862",
  null
  
)

export default component.exports